import { format as d3Format } from 'd3-format';
import { DEFAULT_TIME_FORMATS } from './constants';

export const formatTimeValue = (
  value: string | number,
  customFormat: Partial<typeof DEFAULT_TIME_FORMATS> = {}
): string => {
  const formatSettings = { ...DEFAULT_TIME_FORMATS, ...customFormat };

  if (value == null || value === '' || (typeof value === 'number' && isNaN(value))) {
    return formatSettings.invalidValueText;
  }

  if (typeof value === 'string') {
    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) return formatSettings.invalidValueText;
    value = numericValue;
  }

  return value % 1 === 0 ? d3Format('.0f')(value) : d3Format(formatSettings.secondsFormat)(value);
};
